import request from '@/utils/request'
import { isEmpty } from 'lodash'
// import storage from 'store'
// import { ACCESS_TOKEN } from '@/store/mutation-types'

// export default function selfRequest (params) {
//     params = isEmpty(params) ? {} : params
//     console.log(params);
//     return request({
//       method: 'post',
//       params: params,
//       url:process.env.VUE_APP_API_BASE_URL
//     })
// }

export function selfRequest (params) {
  params = isEmpty(params) ? {} : params
  console.log(params);
  return request({
    method: 'get',
    params: params,
    url:process.env.VUE_APP_API_BASE_URL
  })
}